import React from 'react';
import { Link } from 'gatsby';
import css from './HomeOverlap.module.scss';

const HomeOverlap = () => {
	return (
		<section className={css.homeOverlap}>
			<h2 className="animateOnlyMobile" data-aos="custom-fade-right">
				No commissions.
				<br />
				No hidden costs.
				<br />
				Direct returns.
			</h2>
			<h4 className="animateOnlyMobile" data-aos="custom-fade-right">
				Moneyfront provides up to 1%* higher returns on Direct Mutual Fund
				investment.
			</h4>
			<p className="animateOnlyMobile" data-aos="custom-fade-right">
				Earn higher returns on your Mutual Fund investments with Direct Plans,
				save on commissions, and get financial advice on how to manage
				investments at a low cost.
			</p>
			<div className={`${css.ctaLinks} animateOnlyMobile`}>
				<button className="btn btnGreen">Sign up now</button>
				<Link to="/direct-mutual-funds" className="linkUnderline">
					See for yourself
				</Link>
			</div>
			<div
				className={`${css.compareImg} animateOnlyMobile`}
				data-aos="custom-fade-left"
			>
				<img
					src="/images/home/direct-vs-regular.svg"
					alt="Comparison of direct vs regular mutual funds"
				/>
			</div>
		</section>
	);
};

export default HomeOverlap;
